var check_for_jquery = setInterval(()=>{
  if(typeof($) == "function"){
    clearInterval(check_for_jquery);
    $('head').append('<script src="//cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js"/>');
    $(document).ready(function() {
      if(window.location.href.indexOf("refer") > -1 || window.location.href.indexOf("rewards") > -1) {
        $('body').addClass("swell-rewards-page");
      }
      $(document).on("swell:initialized", function() {
        SwellConfig.Campaign.initializeCampaigns(".swell-campaign-list");
      });

      $(document).on("swell:setup", function() {
        $(".swell-referral-loader").remove();
        SwellConfig.Tier.initializeDummyTier();
        SwellConfig.Tier.initializeCustomTierProperties();
        SwellConfig.Tier.initializeTiers(".swell-tier-table");
        SwellConfig.Tier.applytierSlickSlider(".tier-holder");
        SwellConfig.Tier.setupStatus('.swell-tier-table');
      });


    });
  }
}, 300);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="<%= campaign.icon %>"></span></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> </div> </li>'
      }
    },
    initializeCampaigns: (containerSelector)=>{
      spapi.activeCampaigns.forEach((campaign)=>{
        if(campaign.type != "ReferralCampaign"){
          $(containerSelector).append('<li class="swell-campaign"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal" data-campaign-id="'+campaign.id+'"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="'+campaign.icon+'"></span></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">'+campaign.title+'</span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">'+campaign.reward_text+'</span> </div> </div> </li>');
        }
      });
    }
  };
}).call(this);

// Tier_List_Table Start
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getTierById : function(id) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.id === id;
      })[0];
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        dummy: true,
        name: "VIP TIER 1",
        points: "$0&ndash;$299",
        points_multiplier:" 1",
        exclusive_products: "",
        free_product: "",
        amount_spent_cents: 0,
        referrals_completed: 0,
        points_earned: 0,
        purchases_made: 0,
      });
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    initializeCustomTierProperties: function() {
      var tiers = spapi.activeVipTiers;
        Tier_0 = SwellConfig.Tier.getTierByRank(0);
        Tier_1 = SwellConfig.Tier.getTierByRank(1);
        Tier_2 = SwellConfig.Tier.getTierByRank(2);

      if(Tier_0){
        Tier_0.spend = "$0-$"+((Tier_1.amount_spent_cents/100)-1)+" Spend or<br>0-"+(Tier_1.referrals_completed-1)+" Successful Referrals"; ; 
        Tier_0.entry_reward = "25 points"; 
        Tier_0.free_shipping = ''; 
        Tier_0.birthday_gift = ''; 
        Tier_0.early_access_to_sales = ''; 
        Tier_0.exclusive_opportunities = ''; 
        Tier_0.product_testing_access = ''; 
        Tier_0.class = 'tier_0'; 
      }
      if(Tier_1){
        Tier_1.spend = "$"+(Tier_1.amount_spent_cents/100)+"-$"+((Tier_2.amount_spent_cents/100)-1)+" Spend or<br>"+Tier_1.referrals_completed+"-"+(Tier_2.referrals_completed-1)+" Successful Referrals"; 
        Tier_1.entry_reward = "50 points"; 
        Tier_1.free_shipping = 'UPS ground'; 
        Tier_1.birthday_gift = '100 points'; 
        Tier_1.early_access_to_sales = '<div class="swell-icons-current"></div>'; 
        Tier_1.exclusive_opportunities = ''; 
        Tier_1.product_testing_access = ''; 
        Tier_1.class = 'tier_1'; 
      }
      if(Tier_2){
        Tier_2.spend = "$"+(Tier_2.amount_spent_cents/100)+"+ Spend or<br>"+Tier_2.referrals_completed+"+ Successful Referrals"; 
        Tier_2.entry_reward = "100 points"; 
        Tier_2.free_shipping = 'UPS ground'; 
        Tier_2.birthday_gift = '150 points'; 
        Tier_2.early_access_to_sales = '<div class="swell-icons-current"></div>'; 
        Tier_2.exclusive_opportunities = '<div class="swell-icons-current"></div>'; 
        Tier_2.product_testing_access = '<div class="swell-icons-current"></div>'; 
        Tier_2.class = 'tier_2'; 
      }
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;

      $(containerSelector).append('<li class="titles-col"> <span class="empty"></span><span class="name-item">Benefits</span><span class="list-point-one">Tier entry reward</span><span class="list-point-two">Shipping</span><span class="list-point-three">Birthday gift</span><span class="list-point-four">Early access to new releases & promotions</span><span class="list-point-five">Exclusive opportunities</span><span class="list-point-six">Product testing team access</span> </li>');
      $(containerSelector).append('<li class="tier-holder"> </li>');
      tiers.forEach(function(tier) {
        return $(containerSelector).find(".tier-holder").append('<div class="tier-'+(tier.rank+1)+'-col '+tier.class+'" data-tier-id="'+ tier.id +'"> <span class="points-item">'+tier.spend+'</span> <span class="name-item">'+tier.name+'</span> <span>'+tier.entry_reward+'</span> <span>'+tier.free_shipping+'</span> <span>'+tier.birthday_gift+'</span> <span>'+tier.early_access_to_sales+'</span> <span>'+tier.exclusive_opportunities+'</span> <span>'+tier.product_testing_access+'</span> </div>');
        });
    },
    setupStatus: function(containerSelector){
      if(spapi.authenticated){
        tiers = spapi.activeVipTiers;

        if(spapi.customer.vip_tier){
          current_tier = SwellConfig.Tier.getTierById(spapi.customer.vip_tier.id);
          if(current_tier.rank < tiers.length -1){
            next_tier = SwellConfig.Tier.getTierByRank(current_tier.rank+1);
            dollarRequired = (spapi.customer.vip_tier_stats_needed.amount_cents_needed)/100;
            $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"]').prepend('<div class="current-status">Current status</div>');  
            // $(containerSelector).find('.tier-holder .'+next_tier.class+'[data-tier-id="'+ next_tier.id +'"]').prepend('<div class="tier-encouragement">Spend $'+dollarRequired+' more</div>');  
          }
          else{
            $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"]').prepend('<div class="current-status">Current status</div>');  
          }
          $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"]').addClass("swell-active");
          $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"] .points-item').remove();
        }else{
          if(typeof(SwellConfig.Tier.getTierByRank(0).dummy) !== 'undefined' && SwellConfig.Tier.getTierByRank(0).dummy ){
            current_tier = SwellConfig.Tier.getTierByRank(0);
            next_tier = SwellConfig.Tier.getTierByRank(current_tier.rank+1);
            dollarRequired = (spapi.customer.vip_tier_stats_needed.amount_cents_needed)/100;
            $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"]').prepend('<div class="current-status">Current status</div>');  
            // $(containerSelector).find('.tier-holder .'+next_tier.class+'[data-tier-id="'+ next_tier.id +'"]').prepend('<div class="tier-encouragement">Spend $'+dollarRequired+' more</div>');
            $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"]').addClass("swell-active");
            $(containerSelector).find('.tier-holder .'+current_tier.class+'[data-tier-id="'+ current_tier.id +'"] .points-item').remove();
            $(containerSelector).addClass(SwellConfig.Tier.getTierByRank(0).class);
          }
        }
      }
    },
    applytierSlickSlider: function(containerSelector){
      $(containerSelector).slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToScroll:1,
          slidesToShow: 3,
          prevArrow: false,
          nextArrow: false,
          responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
          ]
      });
    }
  };

}).call(this);
// Tier_list_table End
